import { useTranslation } from 'react-i18next';
import { generatePath, Link, useLocation } from 'react-router-dom';

import { Tab, Tabs } from '@packages/fenrir/components';

import { flowDataTypes } from '../../../flow-data-type';
import { useFlowDataTypeParam } from '../../../hooks/use-flow-data-type-param/use-flow-data-type-param';

export const FlowDataTabs = () => {
  const { t } = useTranslation('flow');

  const { search } = useLocation();
  const flowDataType = useFlowDataTypeParam();

  return (
    <Tabs
      value={flowDataType}
      indicatorColor="primary"
      orientation="horizontal"
      textColor="primary"
    >
      {flowDataTypes.map((flowDataType) => (
        <Tab
          key={flowDataType}
          value={flowDataType}
          label={t(`tabs.${flowDataType}`)}
          to={{
            pathname: generatePath(`/data-explorer/flow/${flowDataType}`),
            search,
          }}
          component={Link}
        />
      ))}
    </Tabs>
  );
};
